import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
    async (config) => {
        try {
            const { tokens } = await import('./TokensApi');
            if (tokens.token) {
                config.headers.Authorization = `Bearer ${tokens.token}`;
            }
        } catch (error) {
            console.error('Erro ao obter o token do arquivo:', error);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;

